import { getCompetitionResults } from "../../../api";

export const fetchCompetitionResults = async ({
  provider,
  discipline,
  competitionIds = [],
  season,
  day = null,
}) => {
  const { data } = await getCompetitionResults({
    provider,
    discipline,
    competitionIds,
    season,
    day,
  });

  return data;
};